import styled from "styled-components"
import mainTheme from "@irati/ui/src/global/theme"

export const ImageCard = styled.img`
  width: ${mainTheme.spacing.eight};
  height: ${mainTheme.spacing.eight};
`
